import React, { useState, useEffect } from 'react';
import { Shield, Eye, AlertTriangle, Activity, Search, Clock, Radio, ChevronRight, RefreshCcw, ExternalLink, X, MessageCircle, FileText, Bell, Users, CheckCircle } from 'lucide-react';
import { API_URL as CONFIG_API_URL } from '../../config';
const API_URL = CONFIG_API_URL || 'http://8.141.122.155:3002/api';

const ACCOUNTS = [
  { name: '宝岛眼镜', type: '全国连锁', freq: '4篇/月', status: '监听中', lastActive: '2小时前' },
  { name: '博士眼镜', type: '全国连锁', freq: '4篇/月', status: '监听中', lastActive: '3小时前' },
  { name: '亮视点', type: '全国连锁', freq: '4篇/月', status: '监听中', lastActive: '5小时前' },
  { name: '明月镜片', type: '品牌竞品', freq: '8篇/月', status: '监听中', lastActive: '5小时前' },
  { name: '爱尔眼科', type: '大型医疗机构', freq: '4篇/月', status: '监听中', lastActive: '1天前' },
  { name: '铭洋视光眼镜店', type: '个体经销商', freq: '2篇/月', status: '监听中', lastActive: '3天前' },
  { name: '杭州视康视光诊所', type: '下沉门店', freq: '6篇/月', status: '监听中', lastActive: '4小时前' },
  { name: '西安瞳星眼镜店', type: '下沉门店', freq: '2篇/月', status: '监听中', lastActive: '5天前' },
];


export default function WeChatRadar({ brandProjectId, dateRange, startDate, endDate }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState('');
  const [drawerFilter, setDrawerFilter] = useState('all');
  const [drawerData, setDrawerData] = useState(null); // 存储传递给抽屉的特定数据

  // 右侧面板状态
  const [rightTab, setRightTab] = useState('alerts'); // 'alerts' | 'accounts'
  const [handledIds, setHandledIds] = useState(new Set());
  const alerts = (data?.radarList || []).map(r => ({...r, id: r.id, title: r.noteTitle, account: "微信公众号", handled: handledIds.has(r.id)}));

  const openDrawer = (title, filterType, specificData = null) => {
    setDrawerTitle(title);
    setDrawerFilter(filterType);
    setDrawerData(specificData);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };
  
  const handleMarkAsRead = (id) => {
    setHandledIds(new Set([...handledIds, id]));
    closeDrawer();
  };

  useEffect(() => {
    const effectiveBrandId = brandProjectId || localStorage.getItem('globalBrand');
    if (effectiveBrandId && effectiveBrandId !== 'all') {
      setLoading(true);
      fetchData(effectiveBrandId);
    } else {
      setLoading(false);
    }
  }, [brandProjectId, dateRange, startDate, endDate]);

  const fetchData = async (id) => {
    try {
      const token = localStorage.getItem('token');
      let url = `${API_URL}/seo-ecology/wechat-radar?brandProjectId=${id}`;
      if (dateRange === 'custom') {
        if (startDate) url += `&startDate=${startDate}`;
        if (endDate) url += `&endDate=${endDate}`;
      } else if (dateRange && dateRange !== 'all') {
        url += `&dateRange=${dateRange}`;
      }

      const res = await fetch(url, { headers: { 'Authorization': `Bearer ${token}` }});
      const json = await res.json();
      if (json.metrics) {
        setData(json);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const getRangeText = () => {
    if (dateRange === 'custom') {
      if (startDate && endDate) return `${startDate} 至 ${endDate}`;
      if (startDate) return `${startDate} 之后`;
      if (endDate) return `${endDate} 之前`;
      return '自定义日期';
    }
    if (dateRange === '1') return '今日';
    if (dateRange === '7') return '近7天';
    if (dateRange === '30') return '近30天';
    return '全部';
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Activity className="w-6 h-6 text-indigo-500 animate-pulse mr-2" />
        <span className="text-slate-500">正在扫描微信公众号全网数据...</span>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-slate-500 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700">
        <Search className="w-12 h-12 text-slate-300 mb-4" />
        <p>暂无数据或请先选择品牌项目</p>
      </div>
    );
  }

  const { radarList } = data;
  const metrics = data.metrics || {};

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      
      {/* 顶部指标卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-slate-200 dark:border-slate-700 shadow-sm flex items-center">
          <div className="w-12 h-12 rounded-lg bg-indigo-50 dark:bg-indigo-500/10 flex items-center justify-center mr-4">
            <Radio className="w-6 h-6 text-indigo-600 dark:text-indigo-400" />
          </div>
          <div>
            <div className="text-sm text-slate-500 dark:text-slate-400">定向监控大号白名单</div>
            <div className="text-2xl font-bold text-slate-800 dark:text-slate-100">100<span className="text-sm font-normal text-slate-500 ml-1">个账号</span></div>
          </div>
        </div>
        <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-slate-200 dark:border-slate-700 shadow-sm flex items-center">
          <div className="w-12 h-12 rounded-lg bg-emerald-50 dark:bg-emerald-500/10 flex items-center justify-center mr-4">
            <Search className="w-6 h-6 text-emerald-600 dark:text-emerald-400" />
          </div>
          <div>
            <div className="text-sm text-slate-500 dark:text-slate-400">扫描增量 <span className="text-xs ml-1 text-emerald-400">({getRangeText()})</span></div>
            <div className="text-2xl font-bold text-slate-800 dark:text-slate-100">125<span className="text-sm font-normal text-slate-500 ml-1">篇</span></div>
          </div>
        </div>
        <div 
          onClick={() => setRightTab('alerts')}
          className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-slate-200 dark:border-slate-700 shadow-sm flex items-center cursor-pointer hover:shadow-md hover:-translate-y-1 transition-all"
        >
          <div className="w-12 h-12 rounded-lg bg-orange-50 dark:bg-orange-500/10 flex items-center justify-center mr-4">
            <Activity className="w-6 h-6 text-orange-600 dark:text-orange-400" />
          </div>
          <div>
            <div className="text-sm text-slate-500 dark:text-slate-400">行业动态预警</div>
            <div className="text-2xl font-bold text-slate-800 dark:text-slate-100">{alerts.filter(a => a.level === 'warning' || a.level === 'hijack').length}<span className="text-sm font-normal text-slate-500 ml-1">条</span></div>
          </div>
        </div>
        <div 
          onClick={() => setRightTab('alerts')}
          className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-slate-200 dark:border-slate-700 shadow-sm flex items-center cursor-pointer hover:shadow-md hover:-translate-y-1 transition-all ring-1 ring-rose-500 shadow-rose-500/20"
        >
          <div className="w-12 h-12 rounded-lg bg-rose-50 dark:bg-rose-500/10 flex items-center justify-center mr-4">
            <AlertTriangle className="w-6 h-6 text-rose-600 dark:text-rose-400" />
          </div>
          <div>
            <div className="text-sm text-slate-500 dark:text-slate-400">高危定向预警 (品牌/产品)</div>
            <div className="text-2xl font-bold text-rose-600 dark:text-rose-400">{alerts.filter(a => a.level === 'critical').length}<span className="text-sm font-normal text-rose-500/70 ml-1">条</span></div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        
        {/* 左侧：全网盲搜雷达 (动态 API) - 缩小为1列或保持，这里保持原样，也可以调整比例 */}
        <div className="lg:col-span-2 space-y-6">
          <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden flex flex-col h-[650px]">
            <div className="p-5 border-b border-slate-200 dark:border-slate-700 flex justify-between items-center bg-slate-50 dark:bg-slate-900/50 flex-shrink-0">
              <div className="flex items-center gap-2">
                <Search className="w-5 h-5 text-emerald-500" />
                <h3 className="font-bold text-slate-800 dark:text-slate-100">公域长尾生态巡检 (微信搜狗动态抓取)</h3>
                <button onClick={() => openDrawer('完整收录大盘', 'serp')} className="ml-4 text-xs font-medium text-indigo-600 hover:text-indigo-700 dark:text-indigo-400 hover:underline flex items-center gap-1">
                  <FileText className="w-3.5 h-3.5" /> 查看搜狗微信抓取完整列表
                </button>
              </div>
              <span className="text-xs px-2 py-1 bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-400 rounded flex items-center gap-1">
                <RefreshCcw className="w-3 h-3" /> 引擎运行中
              </span>
            </div>
            
            <div className="p-5 overflow-y-auto flex-1">
               {(!radarList || radarList.length === 0) ? (
                  <div className="flex flex-col items-center justify-center h-full text-slate-400">
                    <Shield className="w-12 h-12 mb-3 text-emerald-500/30" />
                    <p>当前周期内暂未扫描到风险文章</p>
                  </div>
               ) : (
                  <div className="space-y-4">
                    {radarList.map((item, idx) => {
                        const levelColors = {
                          critical: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-400 dark:border-red-800 font-bold',
                          warning: 'bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-900/30 dark:text-orange-400 dark:border-orange-800 font-bold',
                          hijack: 'bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-400 dark:border-purple-800 font-bold',
                          info: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800 font-bold'
                        };

                        return (
                          <div key={item.id || idx} className="p-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/80 hover:shadow-md transition-shadow">
                            <div className="flex justify-between items-start mb-3">
                              <div className="flex items-center gap-3">
                                <span className={`px-2.5 py-1 rounded-md text-xs border ${levelColors[item.level] || levelColors.info}`}>
                                  {item.levelText}
                                </span>
                                <h4 className="font-medium text-slate-800 dark:text-slate-200 line-clamp-1">{item.noteTitle}</h4>
                              </div>
                              <span className="text-xs text-slate-500 whitespace-nowrap ml-4">{item.time ? new Date(item.time).toLocaleString() : ''}</span>
                            </div>
                            
                            <div className="bg-slate-50 dark:bg-slate-900/50 rounded-lg p-3 text-sm text-slate-600 dark:text-slate-300 mb-3 line-clamp-2">
                              {item.content}
                            </div>
                            
                            <div className="flex justify-between items-center text-xs">
                              <div className="flex items-center gap-4 text-slate-500 dark:text-slate-400">
                                <span className="flex items-center gap-1.5"><Search className="w-3.5 h-3.5" /> 触达词: {item.keyword}</span>
                                <span className="flex items-center gap-1.5"><Activity className="w-3.5 h-3.5" /> 排名: {item.rank}</span>
                              </div>
                              <div className="flex items-center gap-3">
                                {item.sourceLink && (
                                  <a href={item.sourceLink} target="_blank" rel="noreferrer" className="text-indigo-600 dark:text-indigo-400 hover:underline flex items-center gap-1">
                                    <ExternalLink className="w-3.5 h-3.5" /> 查看原文
                                  </a>
                                )}
                              </div>
                            </div>
                            
                            {item.aiSuggestion && (
                              <div className="mt-3 pt-3 border-t border-dashed border-slate-200 dark:border-slate-700">
                                <div className="text-xs flex items-start gap-2">
                                  <Shield className="w-4 h-4 text-indigo-500 shrink-0" />
                                  <span className="text-indigo-700 dark:text-indigo-300"><span className="font-semibold">AI 研判建议:</span> {item.aiSuggestion}</span>
                                </div>
                              </div>
                            )}
                          </div>
                        )
                    })}
                  </div>
               )}
            </div>
          </div>
        </div>
        
        {/* 右侧：定向核心大号监控 (T+1) */}
        <div className="space-y-6">
          <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden flex flex-col h-[650px]">
            {/* Header / Tabs */}
            <div className="p-0 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/50 flex-shrink-0 flex items-center justify-between">
              <div className="flex w-full">
                <button 
                  onClick={() => setRightTab('alerts')}
                  className={`flex-1 py-4 text-sm font-bold border-b-2 flex justify-center items-center gap-2 ${rightTab === 'alerts' ? 'border-rose-500 text-rose-600 dark:text-rose-400 bg-white dark:bg-slate-800' : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'}`}
                >
                  <Bell className="w-4 h-4" /> 舆情预警流
                  {alerts.filter(a => !a.handled).length > 0 && (
                    <span className="bg-rose-500 text-white text-[10px] px-1.5 py-0.5 rounded-full">{alerts.filter(a => !a.handled).length}</span>
                  )}
                </button>
                <button 
                  onClick={() => setRightTab('accounts')}
                  className={`flex-1 py-4 text-sm font-bold border-b-2 flex justify-center items-center gap-2 ${rightTab === 'accounts' ? 'border-indigo-500 text-indigo-600 dark:text-indigo-400 bg-white dark:bg-slate-800' : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'}`}
                >
                  <Users className="w-4 h-4" /> 监控账号库
                </button>
              </div>
            </div>
            
            <div className="p-0 overflow-y-auto flex-1 bg-slate-50/30 dark:bg-slate-950/30">
              
              {/* Tab: Alerts */}
              {rightTab === 'alerts' && (
                <div className="p-4 space-y-4">
                  {alerts.length === 0 ? (
                    <div className="text-center py-20 text-slate-500">今日防守阵地安全，无预警</div>
                  ) : (
                    alerts.map(alert => (
                      <div 
                        key={alert.id} 
                        onClick={() => openDrawer('预警文章详情', 'alert_detail', alert)}
                        className={`p-4 rounded-xl border bg-white dark:bg-slate-800 shadow-sm cursor-pointer hover:shadow-md transition-all ${alert.handled ? 'opacity-50 border-slate-200 dark:border-slate-700' : (alert.level === 'critical' ? 'border-rose-200 dark:border-rose-800/50' : 'border-orange-200 dark:border-orange-800/50')}`}
                      >
                        <div className="flex justify-between items-start mb-2">
                          <span className={`text-xs px-2 py-0.5 rounded font-bold ${alert.level === 'critical' ? 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400' : 'bg-orange-50 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400'}`}>
                            {alert.levelText}
                          </span>
                          <span className="text-xs text-slate-400 flex items-center gap-1">
                            <Clock className="w-3 h-3" /> {alert.time}
                          </span>
                        </div>
                        <h4 className={`font-bold text-sm mb-2 line-clamp-2 ${alert.handled ? 'text-slate-500' : 'text-slate-800 dark:text-slate-200'}`}>
                          {alert.title}
                        </h4>
                        <div className="flex items-center justify-between mt-3">
                          <span className="text-xs text-slate-500 dark:text-slate-400 flex items-center gap-1.5">
                            <Users className="w-3.5 h-3.5" /> {alert.account}
                          </span>
                          {alert.handled && <span className="text-xs text-emerald-500 flex items-center gap-1"><CheckCircle className="w-3 h-3" /> 已处理</span>}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}

              {/* Tab: Accounts */}
              {rightTab === 'accounts' && (
                <div className="divide-y divide-slate-100 dark:divide-slate-700/50">
                  {ACCOUNTS.map((acc, i) => (
                    <div key={i} className="p-4 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors flex items-center justify-between">
                      <div className="flex flex-col">
                        <span className="font-medium text-sm text-slate-800 dark:text-slate-200 mb-1">{acc.name}</span>
                        <div className="flex items-center gap-2 text-xs text-slate-500">
                          <span className="bg-slate-100 dark:bg-slate-700 px-1.5 py-0.5 rounded">{acc.type}</span>
                          <span>{acc.freq}</span>
                        </div>
                      </div>
                      <div className="flex flex-col items-end">
                        <span className="text-xs font-medium text-emerald-600 dark:text-emerald-400 flex items-center gap-1 mb-1">
                          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                          {acc.status}
                        </span>
                        <span className="text-[10px] text-slate-400">活跃: {acc.lastActive}</span>
                      </div>
                    </div>
                  ))}
                  <div className="p-4 text-center">
                    <button className="text-xs text-indigo-600 hover:text-indigo-700 dark:text-indigo-400 transition-colors">
                      查看完整 100 个大号名录...
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
    
      {/* Drawer */}
      <div className={`fixed inset-0 z-[60] transition-opacity duration-300 ${isDrawerOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
        {/* Backdrop */}
        <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={closeDrawer}></div>
        
        {/* Drawer Panel */}
        <div className={`absolute top-0 right-0 h-full w-full sm:w-[500px] bg-white dark:bg-slate-900 border-l border-slate-200 dark:border-slate-800 shadow-2xl transition-transform duration-300 transform flex flex-col ${isDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          
          {/* Header */}
          <div className="px-6 py-4 border-b border-slate-200 dark:border-slate-800 flex items-center justify-between bg-slate-50/50 dark:bg-slate-900/50">
            <h3 className="text-lg font-bold text-slate-800 dark:text-white flex items-center gap-2">
              {drawerFilter === 'alert_detail' || drawerFilter === 'critical' ? <AlertTriangle className="w-5 h-5 text-rose-500" /> : <FileText className="w-5 h-5 text-indigo-500" />}
              {drawerTitle}
            </h3>
            <button onClick={closeDrawer} className="p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:text-slate-300 dark:hover:bg-slate-800 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>
          
          {/* List Content */}
          <div className="flex-1 overflow-y-auto p-6 space-y-4 custom-scrollbar bg-slate-50/30 dark:bg-slate-950/30">
            {(() => {
              if (drawerFilter === 'alert_detail' && drawerData) {
                const alert = drawerData;
                return (
                  <div className="space-y-6">
                    <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-slate-200 dark:border-slate-700 shadow-sm">
                      <div className="flex items-center gap-2 mb-4">
                         <span className={`text-xs px-2 py-0.5 rounded font-bold ${alert.level === 'critical' ? 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400' : 'bg-orange-50 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400'}`}>
                            {alert.levelText}
                         </span>
                         <span className="text-xs text-slate-400">{alert.time}</span>
                      </div>
                      <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-4 leading-snug">{alert.title}</h2>
                      <div className="flex items-center justify-between border-t border-slate-100 dark:border-slate-700/50 pt-4 mt-2">
                         <div className="flex items-center gap-2">
                           <div className="w-8 h-8 rounded-full bg-indigo-100 dark:bg-indigo-900/50 flex items-center justify-center text-indigo-600 dark:text-indigo-400 font-bold text-xs">
                             {alert.account.substring(0,1)}
                           </div>
                           <div className="flex flex-col">
                             <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{alert.account}</span>
                             <span className="text-[10px] text-slate-400">微信公众号</span>
                           </div>
                         </div>
                      </div>
                    </div>
                    
                    <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-5 border border-slate-100 dark:border-slate-700/50">
                      <h4 className="text-sm font-bold text-slate-800 dark:text-slate-200 mb-3 flex items-center gap-2">
                        <Shield className="w-4 h-4 text-indigo-500" /> AI 舆情研判报告
                      </h4>
                      <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed mb-4">{alert.reason}</p>
                      
                      <div className="mb-2 text-xs font-medium text-slate-500">命中防守关键词：</div>
                      <div className="flex flex-wrap gap-2">
                        {alert.hit_keywords.map((kw, i) => (
                          <span key={i} className="bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-400 px-2.5 py-1 rounded-md text-xs font-medium border border-rose-200 dark:border-rose-500/30">
                            {kw}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="pt-4 flex flex-col gap-3">
                      <a href={alert.link} target="_blank" rel="noreferrer" className="w-full flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-xl transition-colors shadow-sm shadow-indigo-600/20">
                        <ExternalLink className="w-4 h-4" /> 跳转微信阅读原文
                      </a>
                      
                      {!alert.handled && (
                        <button 
                          onClick={() => handleMarkAsRead(alert.id)}
                          className="w-full flex items-center justify-center gap-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 font-medium py-3 px-4 rounded-xl transition-colors"
                        >
                          <CheckCircle className="w-4 h-4 text-emerald-500" /> 标记为已处理 (归档)
                        </button>
                      )}
                    </div>
                  </div>
                );
              }

              if (drawerFilter === 'serp') {
                 // Flatten serpData
                 let serpItems = [];
                 (data.serpData || []).forEach(k => {
                    (k.results || []).forEach(r => {
                       serpItems.push({ ...r, keyword: k.keyword });
                    });
                 });
                 if (serpItems.length === 0) return <div className="text-center py-20 text-slate-500">暂无收录数据</div>;
                 
                 // Sort by date descending (from newest to oldest)
                 serpItems.sort((a, b) => {
                     const dateA = new Date(a.date).getTime() || 0;
                     const dateB = new Date(b.date).getTime() || 0;
                     return dateB - dateA;
                 });
                 
                 return serpItems.map((s, idx) => {
                    const parsedDate = s.date && !isNaN(new Date(s.date).getTime()) ? new Date(s.date).toLocaleString() : s.date;
                    return (
                    <div key={idx} className="p-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/80 hover:shadow-md transition-shadow">
                      <div className="flex justify-between items-start mb-2">
                        <div className="text-sm font-bold text-slate-800 dark:text-slate-200 line-clamp-2 pr-4">{s.title}</div>
                        <div className="shrink-0 flex flex-col items-end text-xs">
                            <span className="text-slate-500 dark:text-slate-400 mb-1">{s.media || '未知账号'}</span>
                            <span className="text-slate-400 dark:text-slate-500 scale-90 origin-right">{parsedDate}</span>
                        </div>
                      </div>
                      <div className="text-xs text-slate-600 dark:text-slate-400 mb-4 bg-slate-50 dark:bg-slate-900/50 p-2.5 rounded-lg line-clamp-3 leading-relaxed">{s.desc}</div>
                      <div className="flex justify-between items-center text-xs">
                         <div className="flex items-center gap-3">
                           <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                                  s.status === 'safe' ? 'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400' :
                                  s.status === 'danger' ? 'bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-400' :
                                  s.status === 'warning' ? 'bg-amber-50 text-amber-600 dark:bg-amber-500/10 dark:text-amber-400' :
                                  'bg-rose-50 text-rose-600 dark:bg-rose-500/10 dark:text-rose-400'
                              }`}>
                                {s.type}
                           </span>
                           <span className="flex items-center gap-1 text-slate-500 dark:text-slate-400"><Search className="w-3.5 h-3.5"/> {s.keyword} (Rank: {s.rank})</span>
                         </div>
                         {s.link && <a href={s.link} target="_blank" rel="noreferrer" className="text-indigo-600 hover:text-indigo-700 dark:text-indigo-400 dark:hover:text-indigo-300 font-medium hover:underline flex items-center gap-1"><ExternalLink className="w-3.5 h-3.5"/> 原文</a>}
                      </div>
                    </div>
                 )});
              }

              let items = data.radarList || [];
              if (drawerFilter === 'critical') {
                items = items.filter(c => c.level === 'critical');
              }
              items = [...items].sort((a, b) => (b.likes || 0) - (a.likes || 0));

              if (items.length === 0) {
                return <div className="text-center py-20 text-slate-500 dark:text-slate-400">暂无符合条件的预警数据</div>;
              }

              const levelColors = {
                critical: 'bg-red-50 text-red-700 border-red-200 font-bold',
                warning: 'bg-orange-50 text-orange-700 border-orange-200 font-bold',
                hijack: 'bg-purple-50 text-purple-700 border-purple-200 font-bold',
                info: 'bg-blue-50 text-blue-700 border-blue-200 font-bold'
              };

              return items.map((item, idx) => (
                <div key={idx} className="p-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/80 hover:shadow-md transition-shadow">
                  <div className="flex justify-between items-start mb-3">
                    <div className="flex items-center gap-3">
                      <span className={`px-2.5 py-1 rounded-md text-xs border ${levelColors[item.level] || levelColors.info}`}>
                        {item.levelText}
                      </span>
                      <h4 className="font-medium text-slate-800 dark:text-slate-200 line-clamp-1">{item.noteTitle}</h4>
                    </div>
                    <span className="text-xs text-slate-500 whitespace-nowrap ml-4">{item.time ? new Date(item.time).toLocaleString() : ''}</span>
                  </div>
                  <div className="bg-slate-50 dark:bg-slate-900/50 rounded-lg p-3 text-sm text-slate-600 dark:text-slate-300 mb-3 line-clamp-2">
                    {item.content}
                  </div>
                  <div className="flex justify-between items-center text-xs">
                    <div className="flex items-center gap-4 text-slate-500 dark:text-slate-400">
                        <span className="flex items-center gap-1.5 text-slate-500 dark:text-slate-400"><Search className="w-3.5 h-3.5" /> 触达词: {item.keyword}</span>
                        <span className="flex items-center gap-1.5"><Activity className="w-3.5 h-3.5" /> 排名: {item.rank}</span>
                    </div>
                    {item.sourceLink && (
                      <a href={item.sourceLink} target="_blank" rel="noreferrer" className="text-indigo-600 hover:underline flex items-center gap-1"><ExternalLink className="w-3.5 h-3.5"/> 查看原文</a>
                    )}
                  </div>
                  {item.aiSuggestion && (
                    <div className="mt-3 pt-3 border-t border-dashed border-slate-200 dark:border-slate-700">
                       <div className="text-xs flex items-start gap-2">
                          <Shield className="w-4 h-4 text-indigo-500 shrink-0" />
                          <span className="text-indigo-700 dark:text-indigo-300"><span className="font-semibold">AI 研判建议:</span> {item.aiSuggestion}</span>
                       </div>
                    </div>
                  )}
                </div>
              ));
            })()}
          </div>
        </div>
      </div>
    </div>
  );
}
